import { get, flatMap, map } from "lodash"
import React, { Fragment } from "react"
import AcceptClientSuggestion from './AcceptClientSuggestion'
import SetClient from './SetClient'

const actionsObject = {
  accept_suggested_client: AcceptClientSuggestion,
  set_client: SetClient
}

const actionToDisplay = (auditAction, vm, updateVMs, context) =>  {
  const Component = get(actionsObject, auditAction, Fragment)

  return <Component {...{ vm, updateVMs, ...context }} />
}

const ActionsCell = ({ vm, updateVMs, context }) => (
  <ul className="list-group list-group-flush">
    {flatMap(vm.audit_result, ({ actions }) => map(actions, action => (
      <li className="list-group-item">
        {actionToDisplay(action, vm, updateVMs, context)}
      </li>
    )))}
  </ul>
)

export default ActionsCell
